import type { RouteLocationRaw } from 'vue-router'
import { i18n } from '@/i18n'

export const localizedRoute = (target: RouteLocationRaw): RouteLocationRaw => {
  if (typeof target === 'string') return target

  return {
    ...target,
    params: {
      locale: i18n.global.locale.value,
      ...(target.params ?? {}),
    },
  }
}
